import classNames from 'classnames';
import * as React from 'react';

import './ThumbnailTray.scss';

interface IProps {
  className?: string | object;
}

const ThumbnailTray: React.FunctionComponent<IProps> = (props) => {
  const { children, className } = props;

  const classes = classNames(
    {
      'thumbnail-tray': true,
    },
    className
  );

  return <div className={classes}>{children}</div>;
};

export default ThumbnailTray;
